import script from "./BlogArticleView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogArticleView.vue?vue&type=script&setup=true&lang=js"

import "./BlogArticleView.vue?vue&type=style&index=0&id=4adb9d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4adb9d96"]])

export default __exports__